// components/PWAInstallPrompt.jsx
import { useEffect, useState } from "react";

export default function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsVisible(true);
    };
    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === "accepted") {
        console.log("User accepted the install prompt");
      }
      setIsVisible(false);
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 bg-white shadow-xl border px-4 py-3 rounded-lg z-50 flex items-center gap-4">
      <p className="text-[#055862] font-semibold">Install iDisKover App?</p>
      <button
        onClick={handleInstall}
        className="bg-[#ff7a00] text-white px-4 py-1 rounded hover:bg-[#e86f00] transition"
      >
        Install
      </button>
    </div>
  );
}
